import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { importPdf } from '../api';
import { hasPendingImport, takeCvImport } from '../pendingCvImport';
import './CvImportOverlay.css';

const MIN_MS = 1800; // minimum display so it doesn't flash

export default function CvImportOverlay() {
  const [phase, setPhase] = useState(() => hasPendingImport() ? 'open' : 'done');
  const firedRef = useRef(false);

  useEffect(() => {
    if (phase !== 'open') return;
    if (firedRef.current) return;
    firedRef.current = true;

    const pending = takeCvImport();
    if (!pending) {
      // Stale flag — page was refreshed, File object lost
      localStorage.removeItem('cvflow_cv_import_pending');
      setPhase('done');
      return;
    }

    const { dateiname, file, setupKey } = pending;
    const t0 = Date.now();

    importPdf(dateiname, file)
      .then(() => { localStorage.setItem(setupKey, '1'); })
      .catch(() => { /* setupKey bleibt weg → FirstProfileSetupModal erscheint */ })
      .finally(() => {
        localStorage.removeItem('cvflow_cv_import_pending');
        const remaining = MIN_MS - (Date.now() - t0);
        setTimeout(() => setPhase('closing'), Math.max(0, remaining));
      });
  }, [phase]);

  useEffect(() => {
    if (phase !== 'closing') return;
    const t = setTimeout(() => setPhase('done'), 500); // fade-out duration
    return () => clearTimeout(t);
  }, [phase]);

  if (phase === 'done') return null;

  return createPortal(
    <div className={`cv-import-overlay${phase === 'closing' ? ' cv-import-overlay--out' : ''}`}>
      <div className="cv-import-card">
        <div className="cv-import-spinner" />
        <p className="cv-import-title">Lebenslauf wird gelesen…</p>
        <p className="cv-import-sub">Das dauert nur einen Moment.</p>
      </div>
    </div>,
    document.body
  );
}
